import { Typography } from "@mui/material";
import { CustomTable } from "../../../shared";
import { formatAmount } from "../../../utils";
import { Link } from "react-router-dom";
import React from "react";

export const UnpaidBroughtForward = ({ isStoreAdmin, data = [] }) => {
  const columns = React.useMemo(
    () => [
      {
        Header: "Order No",
        accessor: "order_number",
        Cell: ({ value, row }) => {
          const url = isStoreAdmin
            ? `/store-admin/orders/details/${row?.original?.order_id}`
            : `/orders/details/${row?.original?.order_id}`;
          return (
            value ?
            <Link
              to={url}
              style={{
                fontSize: "14px",
                color: "rgba(23, 23, 23, 1)",
              }}
            >
              {value}
            </Link>: "Brought Forward"
          );
        },
        Footer: () => (
          <Typography
            fontSize="16px"
            fontWeight={600}
            alignItems="center"
            display="flex"
          >
            Total:
          </Typography>
        ),
      },
      {
        Header: "Date",
        accessor: "order_date",
      },
      {
        Header: "Amount",
        accessor: "order_amount",
        Cell: ({ value }) => formatAmount(value),
      },
      {
        Header: "Due",
        accessor: "due",
        Cell: ({ row: { original } }) => {
          const dueAmount = original?.due ? formatAmount(original.due) : "";

          return (
            <Typography fontSize="14px" color="#C07302" fontWeight={700}>
              {dueAmount}
            </Typography>
          );
        },
        Footer: ({ rows }) => {
          const totalDue = rows.reduce((sum, row) => {
            const due = row.original?.due || 0;
            return sum + due;
          }, 0);
          return (
            <Typography
              fontSize="16px"
              fontWeight={600}
              alignItems="center"
              display="flex"
            >
              {formatAmount(totalDue)}
            </Typography>
          );
        },
      },
    ],
    [],
  );

  return (
    <CustomTable
      tableTitle="Unpaid Brought Forward"
      columns={columns}
      data={data}
      defaultSearch={false}
      searchBar={false}
      pagination={false}
      defaultFooter={true}
      footerStyle={{
        backgroundColor: "gray.90",
        height: "48px",
      }}
    />
  );
};
